import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return <div className="empty-page page-pad"><span className="phase-label"><span>404</span> // Lost reference</span><h1>This page left no trace.</h1><Link className="button button-primary" to="/">Return home</Link></div>;
}
